/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import {
  Component,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  ElementRef,
  ChangeDetectorRef,
  Renderer2,
  NgZone
} from '@angular/core';

import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { ChangedEvent, TextService, ResourceService } from '@typescript-kit/core';
import { ImageModel, ImageFieldKey, ViewComponentKey } from '@typescript-kit/view';

import { BaseDirective } from '../../directive/base.directive';

// TYPE SVG_CODE NOT WORKING WITH IE 11

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'kit-svg',
  templateUrl: './svg.component.html',
  styleUrls: ['./svg.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SvgComponent extends BaseDirective<ImageModel> {
  private _source: string;
  private _svg: SafeHtml;

  constructor(
    changeDetector: ChangeDetectorRef,
    elementRef: ElementRef,
    renderer: Renderer2,
    ngZone: NgZone,
    textService: TextService,
    private readonly sanitizer: DomSanitizer,
    private readonly resourceService: ResourceService
  ) {
    super(changeDetector, elementRef, renderer, ngZone, textService);
  }

  get hostClass(): string {
    return 'kit-svg';
  }

  get source(): string {
    return this._source;
  }

  get svg(): SafeHtml {
    return this._svg;
  }

  protected onModelChanged(model: ImageModel) {
    super.onModelChanged(model);
    this.refreshSource();
  }

  protected onModelPropertyChanged(event: ChangedEvent): void {
    super.onModelPropertyChanged(event);
    if (event.changes[ImageFieldKey.SOURCE]) {
      this.refreshSource();
    }
  }

  private refreshSource() {
    const source = this.resourceService.getResource(this.model.source) || this.model.source;
    if (source === this._source) {
      return;
    }
    this._source = source;
    if (this.model.type === ViewComponentKey.SVG_CODE) {
      this._svg = this.sanitizer.bypassSecurityTrustHtml(source);
    }

  }

}
